export class BooleanDate {

    checked: Boolean = false;
    timestamp: Date = new Date();
    // private _timestamp: Date = new Date();
    // get timestamp(): Date {
        // console.log(this._timestamp);
        // console.log(new Date(this._timestamp));
        // return new Date(this._timestamp);
    // }
    // set timestamp(ts: Date) {
        // console.log(this._timestamp);
        // console.log(ts);
        // this._timestamp = ts;
    // }

}



// WEBPACK FOOTER //
// ./client/app/shared/models/boolean-date.model.ts